import SwalDefault from "sweetalert2";
import { useThemeMode } from "@/../_metronic/partials";

export function useSwal() {
	const { mode } = useThemeMode();

	const Swal = SwalDefault.mixin({
		position: "center",
		cancelButtonText: "Cancelar!",
		cancelButtonColor: "#C62E2E",
		confirmButtonColor: "#3085d6",
		background: mode === "dark" ? "#151525" : undefined,
	});

	const Toast = SwalDefault.mixin({
		toast: true,
		position: "top-end",
		showConfirmButton: false,
		timer: 3000,
		timerProgressBar: true,
		background: mode === "dark" ? "#151525" : undefined,
		customClass: {
			timerProgressBar: mode === "dark" ? "swal2-progress-bar-dark" : undefined,
		},
		didOpen: (toast: Element) => {
			toast.addEventListener("mouseenter", SwalDefault.stopTimer);
			toast.addEventListener("mouseleave", SwalDefault.resumeTimer);
		},
	});

	function toastEndpointErrors(errors?: GenericObject | null) {
		const messages = Object.values<string>(errors || {});
		messages.forEach((message) => Toast.fire({ icon: "error", title: message }));
	}

	return { Swal, Toast, toastEndpointErrors };
}
